module.exports = __webpack_public_path__ + "img/fruit-asian-pears-190x100.098b256c.jpg";